import cn from 'classnames';
import React, { FC, useEffect, useRef } from 'react';

import styles from './MobileFooter.module.scss';

type MobileFooterProps = {
  className?: string;
  testID?: string;
  children?: React.ReactNode;
};

export const MobileFooter: FC<MobileFooterProps> = (props) => {
  const { className, testID, children } = props;

  const footerRef = useRef<HTMLElement>(null);

  // Fixed overlays (the agent chat resting bar) read this to stay clear of
  // the footer actions; it only exists while a footer is mounted.
  useEffect(() => {
    const footerElement = footerRef.current;
    if (!footerElement) {
      return;
    }

    const updateFooterHeight = () => {
      document.documentElement.style.setProperty(
        '--mobileFooterHeight',
        `${footerElement.offsetHeight}px`,
      );
    };

    updateFooterHeight();

    const resizeObserver = new ResizeObserver(updateFooterHeight);
    resizeObserver.observe(footerElement);

    return () => {
      resizeObserver.disconnect();
      document.documentElement.style.removeProperty('--mobileFooterHeight');
    };
  }, []);

  return (
    <footer
      ref={footerRef}
      className={cn(styles.container, className)}
      data-testid={testID}
    >
      {children}
    </footer>
  );
};
